var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSensitive = function SvgSensitive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f6145a",
    "data-name": "Sensitive Content Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.053 13.058-8.137 7.845C53.361 16.68 46.909 13.492 40 13.492c-20.675 0-37.435 28.38-37.435 28.38a86.2 86.2 0 0 0 15.433 18.465l-8.234 7.935 3.785 3.926 57.289-55.216ZM27.187 41.872a12.8 12.8 0 0 1 20.552-10.2L29.527 49.227a12.7 12.7 0 0 1-2.339-7.355Z",
    "data-name": "Path 786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.416 25.621 52.048 37.542a12.8 12.8 0 0 1-16.824 16.216L23.781 64.787c4.907 3.223 10.408 5.466 16.22 5.466 20.675 0 37.433-28.38 37.433-28.38a87.5 87.5 0 0 0-13.018-16.252",
    "data-name": "Path 787"
  }))));
};
export default SvgSensitive;